const About = () => {
  return (
    <>
      <p>This is a new about page</p>
    </>
  );
};

export default About;